module.exports = __webpack_public_path__ + "web_static/img/yellow_box_gif.053a67e0.gif";